import React, { useEffect, useState } from 'react';

import { ConfirmPasswordPresentational } from './confirm-password-presentational';
import { useParams } from 'react-router-dom';
import Axios from 'axios';
import { message } from 'antd';
import { appConstant, apiUrl } from '@constants';
import ActionsApp from '@sharedComponent/app-action-reducer/action';
import { connect } from 'react-redux';
import Actions from '../../login/action';

const ConfirmPasswordFunctional = ({ history, props, appLoading, login }) => {
	const formRef = React.createRef();
	const [clientData, setclientData] = useState(null);
	useEffect(() => {
		fetch('https://geoip-db.com/json/')
			.then((res) => res.json())
			.then((json) => setclientData(json));
	}, []);

	const [state, setState] = useState({
		userSecretKey: null,
		email: '',
		userName: '',
		accessLevel: '',
		newPassword: '',
		confirmPassword: '',
		authToken: '',
		buttonLoading: false,
	});

	const componentDidMount = () => {
		// Axios.get(`${appConstant.domain}/Users/${params.id}`)
		Axios.get(`${appConstant.domain}${apiUrl.GET_USER}${params.id}`)
			.then((res) => {
				if (res.data.success) {
					setState({
						...state,
						email: (res.data.messages && res.data.messages.email) || '',
						userName: (res.data.messages && res.data.messages.userName) || '',
						accessLevel: (res.data.messages && res.data.messages.accessLevel) || '',
					});
				} else {
					message.error(res.data && res.data.messages && res.data.messages[0]);
				}
			})
			.catch((e) => {
				if (e.response) {
					message.error(e.response && e.response.data && e.response.data.messages && e.response.data.messages[0]);
				}
			});
	};

	const onFinish = (values) => {
		if (values.newPassword.trim() === values.confirmPassword.trim()) {
			const request = {
				newPassword: values.newPassword,
				authKey: params.id,
			};
			setState({ ...state, buttonLoading: true });
			Axios.get(`${appConstant.domain}/HealthCheck`)
				.then((res) => {
					Axios.put(`${appConstant.domain}${apiUrl.RESET_FORGOT_PASSWORD}`, request)
						.then((res) => {
							if (res.data.success) {
								message.success('Password Created successfully');
								let request1 = {};
								request1.userName = state.userName;
								request1.password = values.newPassword;
								login({ ...request1, userName: request1.userName, ipAddress: clientData.IPv4 }, history);

								//previous code
								// Axios.post(`${appConstant.domain + apiUrl.LOGIN}`, request1)
								// 	.then((res) => {
								// 		localStorage.setItem('userSecretKey', JSON.stringify(btoa(res.data.messages.userSecretKey)));
								// 		localStorage.setItem('authToken', JSON.stringify(btoa(res.data.messages.authToken)));
								// 		appLoading();
								// 		props.history.push('/dashboard');
								// 	})
								// 	.catch((e) => {
								// 		if (e.response) {
								// 			message.error(e.response.data && e.response.data.messages && e.response.data.messages[0]);
								// 		}
								// 	});
							} else {
								message.error(res.data.messages && res.data.messages[0]);
								setState({ ...state, buttonLoading: false });
							}
						})
						.catch((err) => {
							setState({ ...state, buttonLoading: false });
						});
				})
				.catch((err) => {
					setState({ ...state, buttonLoading: false });
				});
		} else {
			message.error(`Password and Confrim Password doesn't Match \n Try Again`);
		}
	};

	const params = useParams();

	useEffect(() => {
		componentDidMount();
	}, []);
	return <ConfirmPasswordPresentational props={props} formRef={formRef} state={state} onFinish={onFinish} />;
};

const mapDispatchToProps = (dispatch) => {
	return {
		appLoading: () => dispatch(ActionsApp.creators.appLoading()),
		login: (request, history) => dispatch(Actions.creators.login(request, history)),
	};
};

const Connected = connect(null, mapDispatchToProps)(ConfirmPasswordFunctional);

export default Connected;
